import cloneDeep from 'lodash.clonedeep';

import { IGenericObject } from '../typings/common-types';

/**
 * Utility function to check valid model
 * @param model
 */
export const validateModel = (model: unknown): IGenericObject => {
  if (typeof model === 'object') {
    return model as IGenericObject;
  } else if (typeof model === 'string') {
    return JSON.parse(model);
  } else {
    return {};
  }
};

export const isEmptyObject = (object: IGenericObject) => !Object.keys(object).length;

export const isValidObject = (object: IGenericObject) => object && !isEmptyObject(object);

/** Check if is subscription model */
export const isSubscriptionModel = (model: IGenericObject | null) => model?.subscription;

/** Check if is query model */
export const isQueryModel = (model: IGenericObject | null) => model?.query;

export const getModelFromUseService = (model: IGenericObject | null) => {
  const modelValidate = isSubscriptionModel(model) ? model?.subscription : model;
  return cloneDeep(isQueryModel(model) ? model?.query : modelValidate);
};
